import "./index.scss";
import "./responsive.scss";

import React, { useEffect } from "react";
import { CallIcon } from "@src/assets/svg";
import { useSelector } from "react-redux";
import { getShareInfoSelector } from "@store/common/selectors";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const isServer = typeof window === "undefined";
const WOW = !isServer ? require("wowjs") : null;

export const ButtonFixed = ({ allowLeft = true, allowRight = true }) => {
  const formData = useSelector((state) => getShareInfoSelector(state));

  const { t } = useTranslation();
  useEffect(() => {
    new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 20,
      mobile: true,
      live: true,
    }).init();
  }, []);

  return (
    <div className="button__fixed">
      {allowLeft && (
        <div className="fixed__left-button">
          <a
            onClick={() => window.open(formData.link_5PTB, "_blank").focus()}
            className=" btn-action btn-fixed"
          >
            <div
              className=" btn-fixed__label wow backInLeft backOutLeft"
              data-wow-duration="2s"
              data-wow-delay="5s"
            >
              <span data-wow-delay="5s" className="wow backInLeft">
                {formData.time_5PTB}
              </span>
            </div>
            <div className="btn-fixed__img wow roteIn" data-wow-delay="0.8s">
              <img src={formData.logo_5PTB} alt="5-minutes" />
            </div>
            <div className="shape4 rotateme">
              <img
                src={require("@src/assets/images/btn-animation.png").default}
                alt="img"
              />
            </div>
          </a>
        </div>
      )}
      {allowRight && (
        <div className="fixed__right-button">
          <Link
            to="/download"
            className="btn-action-right btn-action-right-blue btn-fixed"
          >
            <span>{t("COMMON:productExperience")}</span>
          </Link>
          <a
            className="btn-action-right btn-action-right-yellow btn-fixed"
            href="tel:0939279868"
          >
            <div className="ico">
              <CallIcon />
            </div>
            <div className="btn-fixed__label">
              <span>0939 279 868</span>
            </div>
          </a>
        </div>
      )}
    </div>
  );
};

export default ButtonFixed;
